import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordForm"] */ "/workspace/src/components/auth/forgot-password-form.tsx");
